import { dnmCategoryMap } from "@/constant/home";
const ancestor = "首页";
const HomeRouter = [
  {
    path: "/home",
    name: "home",
    meta: { screen: false, title: "首页", keepAlive: true, ancestor },
    component: () => import("@/views/home/Index.vue"),
    children: [],
  },
  {
    path: "/dynamic-pub/:category",
    name: "dynamic-pub",
    meta: { screen: false, title: "发布动态", ancestor },
    component: () => import("@/views/home/dynamicPub/Index.vue"),
    beforeEnter: (to, from, next) => {
      const { category } = to.params;
      const title = dnmCategoryMap.get(category);
      if (!title) return next("/404");
      to.meta.title = "发布" + title;
      next();
    },
  },
  {
    path: "/dynamic-edit/:category/:id",
    name: "dynamic-edit",
    meta: { screen: false, title: "编辑动态", ancestor },
    component: () => import("@/views/home/dynamicPub/Index.vue"),
    beforeEnter: (to, from, next) => {
      const { category } = to.params;
      const title = dnmCategoryMap.get(category);
      if (!title) return next("/404");
      to.meta.title = "编辑" + title;
      next();
    },
  },
  {
    path: "/dynamic-detail/:category/:id",
    name: "dynamic-detail",
    meta: { screen: false, title: "动态详情", ancestor },
    component: () => import("@/views/home/dynamicDetail/Index.vue"),
    beforeEnter: (to, from, next) => {
      const { category } = to.params;
      const title = dnmCategoryMap.get(category);
      if (!title) return next("/404");
      to.meta.title = title + "详情";
      next();
    },
  },
];
export default HomeRouter;
